/**
 * Auto-updater state, shared by main (which owns it), the preload bridge, and
 * the Settings panel that renders it.
 */

export type UpdaterPhase =
  /** The updater cannot run here — see `disabledReason`. */
  | 'disabled'
  /** Running, nothing to do. */
  | 'idle'
  | 'checking'
  /** An update exists but the updater is switched off, so it was not downloaded. */
  | 'available'
  /** An update exists and downloads once the booth is free (no session, print or upload). */
  | 'waiting'
  | 'downloading'
  /** Downloaded. Installs the next time the app opens, or from Settings. */
  | 'ready'
  /** The app just opened with an update an earlier run downloaded: installs at `installAt` unless skipped. */
  | 'install-countdown'
  /** A new major version exists; it is never installed unattended. */
  | 'major-available'
  | 'error'

export interface UpdaterState {
  phase: UpdaterPhase
  currentVersion: string
  /** Version the feed is offering, once we know of one. */
  availableVersion: string | null
  downloadPercent: number | null
  /** When the launch install starts (epoch ms), during 'install-countdown'. */
  installAt: number | null
  /** Why the updater is off, when it is. */
  disabledReason: string | null
  error: string | null
  /** The operator toggle, independent of whether the updater can run at all. */
  enabled: boolean
  /** Whether this build's brand ships an update feed. */
  brandSupported: boolean
}

/**
 * `installNow()` refusal while a session, print or upload is running. Settings
 * shows its own message for it rather than this code.
 */
export const INSTALL_REFUSED_BUSY = 'booth-busy'
